import { View } from '@play-co/timestep-core/ui';
import * as config from './uiConfig';
import { DescriptiveScript } from 'src/replicant/conversation/conservation.ruleset';
import StateObserver from 'src/StateObserver';
import ButtonScaleViewWithText from 'src/lib/ui/components/ButtonScaleViewWithText';
import i18n from 'src/lib/i18n/i18n';
import * as Conversation from 'src/replicant/conversation';
import PopupBasic from 'src/game/components/popups/PopupBasic';
import sounds from 'src/lib/sounds';
import LangBitmapFontTextView from 'src/lib/ui/components/LangBitmapFontTextView';
import { TextInput } from '../shared/TextInput';
import { GCInstant as platform } from 'src/lib/gcinstant';
import {
  getPlayerIdFromConversation,
  getScriptQuestion,
} from 'src/game/conversation/conversation.utils';

import { AssetGroup } from '@play-co/timestep-core';

type CloseHandler = (answer?: string) => void;

export default class PopupDescriptiveScript extends PopupBasic {
  private close: CloseHandler;
  private maxLength: LangBitmapFontTextView;
  private inputView: TextInput;
  private buttonOkay: ButtonScaleViewWithText;

  constructor(opts: { superview: View; close: CloseHandler }) {
    super({
      ...opts,
      ...config.descriptive.popup,
      boxOpts: config.box,
      tracking: { feature: 'conversation', $subFeature: 'descriptive' },
    });
    this.close = opts.close;

    this.bg.updateOpts(config.bg);
    this.buttonClose.removeFromSuperview();
    this.message.updateOpts(config.descriptive.message);

    this.maxLength = new LangBitmapFontTextView({
      ...config.descriptive.maxLength,
      superview: this.box,
    });

    this.inputView = new TextInput({
      tag: 'textinput',
      superview: this.box,
      ...config.descriptive.input,
    });

    this.buttonOkay = new ButtonScaleViewWithText({
      ...config.descriptive.button,
      superview: this.box,
      localeText: () => i18n('basic.okay'),
      onClick: async () => {
        sounds.sfx.play('ok');
        return opts.close(this.inputView.text ?? this.inputView.placeholder);
      },
    });
    this.buttonOkay.setDisabled(true);
  }

  protected getAssetsGroup() {
    return new AssetGroup([
      'assets/ui/conversation/speechbubble.png',
      'assets/ui/conversation/speechbubble_tail.png',
      'assets/ui/conversation/speechbubble_tap_icon.png',
    ]);
  }

  public init({ id, max_len, move_to }: DescriptiveScript) {
    const { user, ui } = StateObserver.getState();

    super.init({
      id,
      move_to,
      message: getScriptQuestion(
        user,
        id,
        ui.locale,
        getPlayerIdFromConversation(id) !== platform.playerID,
      ),
    });

    this.maxLength.localeText = () =>
      i18n('conversation.maxLength', { maxLength: max_len });

    this.inputView.updateOpts({ minLength: 1, maxLength: max_len });
    this.inputView.on('InputValidated', (valid: boolean) => {
      this.buttonOkay.setDisabled(!valid);
    });
  }
}
